// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  mapName: __t.string(),
  numTeams: __t.u32(),
  armyBudget: __t.u32(),
  maxArmySize: __t.u32(),
  ruleset: __t.string(),
  season: __t.string(),
  startTimeHour: __t.f64(),
};
